export default [
  {
    path: '/suivi/',
    component: () => import('src/pages/suivi/Index.vue'),
    children: [
      {
        path: 'list',
        name: 'listSuivi',
        component: () => import('src/pages/suivi/List.vue')
      },
      {
        path: 'edit/:id?',
        name: 'editSuivi',
        component: () => import('src/pages/suivi/Edit.vue'),
        props: true
      },
      {
        path: 'create',
        name: 'CreateSuivi',
        component: () => import('src/pages/suivi/Edit.vue'),
        props: true
      },
      {
        path: 'view/:id',
        name: 'viewSuivi',
        component: () => import('src/pages/suivi/View.vue'),
        props: true
      }
    ]
  }
];
